import React from "react";

import { useEventTracker } from "hooks/useEventTracker";
import { Action, Category } from "utils/trackEvent";

import LogoIcon from "components/Icons/logo.svg";

export const Logo = () => {
  const { publishEvent } = useEventTracker();

  return (
    <a
      data-testid="logo"
      aria-label="Leafly"
      className="text-green flex-shrink-0 header__logo"
      href="/"
      onClick={() =>
        publishEvent({
          action: Action.click,
          category: Category.header,
          label: "leafly_logo_home",
        })
      }
    >
      <LogoIcon width="70" height="24" />
    </a>
  );
};
